export default {
    'profile': 'About me',
    'changeLanguage': 'Change Language',
    'addDeliveryOrder': 'Create Delivery Order'
}